import { render, staticRenderFns } from "./CardFeature.vue?vue&type=template&id=0789e694&"
import script from "./CardFeature.vue?vue&type=script&lang=js&"
export * from "./CardFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardFeature.vue"
export default component.exports